export default __webpack_public_path__ + "e3ab8edea2794aaa3ddb59ffbd418eac.woff2";